import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import WebhooksTable from '../Components/WebhooksTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [webhook, setSelectedWebhook] = useState(undefined);
    const [webhookValue, setWebhookValue] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: webhooks, loading }, refetch] = useAxios("/internal/cobrand/webhooks");

    if (loading) return <Spinner className="absolute-center" label="Loading Webhooks..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Redirect Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <WebhooksTable
                webhooks={webhooks}
                setSelectedWebhook={setSelectedWebhook}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, webhookName) => {
                    setSelectedWebhook(id);
                    setWebhookValue(webhookName || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/cobrand/webhook/delete/${webhook}/`}
                resourceName={webhookValue}
                resourceType="webhook"
                confirmationValue={webhookValue || undefined}
            />
        </>
    );
};

export default DefaultPage;
